'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getSubDomain = exports.getSubDomain = function () {
  return window.location.host.split('.')[0];
};